import 'core-js/stable';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import CoreuiVue from '@coreui/vue';
import { BootstrapVue, BootstrapVueIcons, IconsPlugin } from 'bootstrap-vue'
// import { iconsSet as icons } from './assets/icons/icons.js';
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-loading-overlay/dist/vue-loading.css';
// import { library } from '@fortawesome/fontawesome-svg-core'
// import { faEye, faPlus, faEdit } from '@fortawesome/free-solid-svg-icons'
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// import lodash from 'lodash'
import axios from 'axios';
import store from './store';
import helper from './helper';
// import qs from 'qs';
import Loading from 'vue-loading-overlay';
import QrcodeVue from 'qrcode.vue';
// import PageSizer from './globals/PageSizer.vue';
// import Multiselect from 'vue-multiselect';
// import VueSkeletonLoader from 'skeleton-loader-vue';
// import VueMoment from 'vue-moment';

// library.add(faEye)
// library.add(faPlus)
// library.add(faEdit)

Vue.config.productionTip = false
var token = localStorage.getItem("token");
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
axios.defaults.timeout = 300000;
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.post['Accept'] = 'application/json';
axios.defaults.paramsSerializer = function(params) {
  return qs.stringify(params, { encoder: function(str){
    return encodeURIComponent(str);
  }});
}

router.beforeEach((to, from, next) => {

  token = store.state.token; //Don't use global token above;
  // token = localStorage.getItem("token"); //Don't use global token above;
  axios.defaults.headers.common['Authorization'] = token;
  // always allow access to 404 and 401
  if (to.name == "Page 404" || to.name == "Page 401"){
    return next()
  }
  // check before accessing routes requiring auth
  else{
    // if attempting auth
    // if(to.name == 'Auth'){
    //   if(token){
    //     return next({ name: 'Menu' })
    //   }
    //   else{
    //     return next()
    //   }
    // }
    if(to.name == 'Text' || to.name == 'Docs' || to.name == 'Docs2'){
      return next()
    }
    // if auth
    else if(token){
        return next()
    }
    // if not yet auth
    else{
      axios.defaults.headers.common['Authorization'] = ""
      store.commit('set', ['token', ""]);
      return next({ name: 'Page 401' })
    }
  }
})
// let errorLabel = {
//   generic: 'Error!',
//   emptyField: '-'
// };

Vue.use(CoreuiVue);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(IconsPlugin);
// Vue.use(VueMoment);
Vue.component('Loading', Loading);
Vue.component('Qrcode', QrcodeVue);
// Vue.component('Multiselect', Multiselect);
// Vue.component('Skeleton', VueSkeletonLoader);
// Vue.component('PageSizer', PageSizer);
// Vue.component('FaIcon', FontAwesomeIcon)
// Vue.prototype.$lodash = lodash;
Vue.prototype.$axios = axios;
Vue.prototype.$helper = helper;
// Vue.prototype.$errorLabel = errorLabel;
// Vue.prototype.$appType = 'FMC_';
// Vue.prototype.$realm = 'fmc';

const rootApp = new Vue({
  el: '#app',
  router,
  store,
  // icons,
  template: '<App></App>',
  components: {
    App,
  },
});

rootApp;
